import { useInformation } from "@/api/services/admin/information";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { InformationForm } from "@/features/information/components/InformationForm";
import { convertInformationDetailToForm } from "@/features/information/utils/convert";
import { useInformationListSessionStorage } from "@/hooks/useInformationListSessionStorage";
import { isNumber } from "@/utils/number";
import { FC, useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";

type TInformationEditPageProps = {};

export const InformationEditPage: FC<TInformationEditPageProps> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getBackUrl } = useInformationListSessionStorage();
  const { data: informationResult, isLoading, isError } = useInformation();
  const informationData = informationResult?.data;
  const backUrl = useMemo(() => getBackUrl(), [getBackUrl]);

  useEffect(() => {
    if (!id || !isNumber(id)) {
      navigate(backUrl, { replace: true });
    }
  }, [id, navigate, backUrl]);

  useEffect(() => {
    if (id && isNumber(id) && !isLoading && (isError || !informationData)) {
      navigate(backUrl, { replace: true });
    }
  }, [id, isLoading, isError, informationData, navigate, backUrl]);

  if (isLoading || !informationData) return <LoadingPage />;
  return <InformationForm previousData={convertInformationDetailToForm(informationData)} backUrl={backUrl} />;
};
